export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'FRIENDS_LOCATION_GET':
      return payload
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
